import { TagsMultiSelect } from "@goodfill/blueprint-tag-multi-select";
import { calculateContrastTextColorForBackground, calculateRandomColorFromSeed } from "@goodfill/color";
import "./StringListFilter.scss";

const identityFunction = <T,>(a: T): T => a;

const tagColorStyle = (text: string) => {
  const backgroundColor = calculateRandomColorFromSeed(text);

  return {
    backgroundColor,
    color: calculateContrastTextColorForBackground(backgroundColor),
  };
};

export function StringListFilterComponent({
  selected,
  onChange,
  items,
  small,
}: {
  selected: string[];
  onChange: (value: string[]) => void;
  items: string[];
  small?: boolean;
}) {
  return (
    <TagsMultiSelect<string>
      small={small}
      onChange={onChange}
      getTagName={identityFunction}
      getTagKey={identityFunction}
      getTagStyle={tagColorStyle}
      selectedTags={selected}
      tags={items}
      tagQueryMatcher={(query, tag) => tag.toLowerCase().includes(query.toLowerCase())}
      className="StringListFilter"
      popoverProps={{ matchTargetWidth: true }}
    />
  );
}
